import React from "react";
import _ from "lodash";
import moment from "moment";
import PropTypes from "prop-types";
import cx from "classnames";
import Modal from "../modal";
import fromIntensity from "../../utils/get-zone";
const id = "modal-toggle-copy-exercise";

const {
  DATE_FORMATS: { DATE_YEAR_FORMAT, DATE_DAY_FORMAT },
} = require("../../constants");

function CopyExerciseModal(props, { locals }) {
  const { activeUser, copyExercises, query } = locals;

  const activeDay = moment.utc(query.day, DATE_DAY_FORMAT).startOf("day");
  const selectedMonth = moment.utc(
    _.get(query, "modal.date"),
    DATE_YEAR_FORMAT
  );
  const dayRange = _.map(_.range(-3, 4), (i) =>
    selectedMonth.clone().add(i, "months")
  );

  return (
    <form action="/actions/exercise/copy-day" method="POST" data-noreset>
      <input type="hidden" name="type" value="import" />
      <input type="hidden" name="to" value={activeDay.toJSON()} />
      <Modal name={id} key={id} className="Import-Workout">
        <div className="head">
          <h2 className="alt">Select A Workout To Copy</h2>
        </div>

        <div className="body" style={{ maxHeight: "calc(90vh - 260px)" }}>
          {_.chain(copyExercises)
            .sortBy("date")
            .groupBy(({ date }) => moment.utc(date).format(DATE_DAY_FORMAT))
            .omit([activeDay.format(DATE_DAY_FORMAT)])
            .map((exercises, day) => {
              const date = moment.utc(day, DATE_DAY_FORMAT).startOf("day");
              return (
                <div key={day} className="Workout">
                  <div className="day-label">
                    <label className="radio-input">
                      <input
                        type="radio"
                        name="from"
                        defaultValue={date.toJSON()}
                      />
                      <span className="text">
                        {date.format("dddd")}
                        <b>{date.format("MMM D")}</b>
                      </span>
                      <span className="radio"></span>
                    </label>
                  </div>

                  <div className="details">
                    {_(exercises)
                      .map((exercise) => {
                        const primary = _.get(exercise, "primary");
                        const defaultRepMax = locals.fromMetric(
                          _.get(
                            exercise,
                            `repMaximums.${primary}`,
                            _.get(activeUser, `repMaximums.${primary}`, 0)
                          )
                        );
                        const isAssistant = primary === "assistant";
                        const equipped =
                          !isAssistant && _.some(exercise.sets, "equipped");

                        return (
                          <div
                            className={cx("Exercise collapsible", primary, {
                              equipped,
                            })}
                            key={exercise._id}
                          >
                            <input
                              type="checkbox"
                              id={`exercise-toggle-${exercise._id}`}
                            />

                            <div className="head">
                              <label
                                className="expand-toggle"
                                htmlFor={`exercise-toggle-${exercise._id}`}
                              />
                              {_.capitalize(primary)}{" "}
                              {exercise.secondary &&
                                `(${_.capitalize(exercise.secondary)})`}
                            </div>

                            <div className="details">
                              <div className="details-col-1">
                                {_.map(exercise.sets, (it) => {
                                  const equippedRepMax = locals.fromMetric(
                                    it.equippedRepMax
                                  );
                                  const repMax =
                                    equippedRepMax || defaultRepMax;
                                  const load = locals.fromMetric(it.load);
                                  const percentRM = _.round(
                                    (load / repMax) * 100,
                                    1
                                  );
                                  const isEquipped =
                                    !isAssistant && it.equipped;
                                  const hasLoad = Boolean(load);
                                  return (
                                    <div className="routine">
                                      <div>
                                        <b>Sets</b> {it.sets}
                                      </div>
                                      <div>
                                        <b>Reps</b> {it.reps}
                                      </div>
                                      {hasLoad && (
                                        <div>
                                          <b>Load</b> {locals.withWeight(load)}
                                        </div>
                                      )}
                                      {hasLoad && !isAssistant && (
                                        <div>
                                          <b>Intensity</b> {percentRM}%
                                        </div>
                                      )}
                                      {it.rpe > 0 && (
                                        <div>
                                          <b>RPE</b> {it.rpe}
                                        </div>
                                      )}
                                      <div className="zone">
                                        {!isAssistant && (
                                          <span
                                            className={`zone-dot ${fromIntensity(
                                              percentRM,
                                              it.reps
                                            )}`}
                                          ></span>
                                        )}
                                        &nbsp;
                                      </div>

                                      {isEquipped && (
                                        <div>
                                          <b>Equipped</b> {it.equipment}
                                        </div>
                                      )}

                                      {isEquipped && (
                                        <div>
                                          <b>Equipped RM</b>{" "}
                                          {locals.withWeight(equippedRepMax)}
                                        </div>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                              <div className="details-col-2">
                                {exercise.notes && (
                                  <div className="notes">
                                    <b>Notes</b> {exercise.notes}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })
                      .value()}
                  </div>
                </div>
              );
            })}
        </div>

        <div className="foot centered-text">
          <div className="Day-Slider">
            <div className="days">
              <a
                className="prev"
                href={`/actions/refresh?modal[type]=copy&modal[date]=${selectedMonth
                  .clone()
                  .add(-1, "months")
                  .format(DATE_YEAR_FORMAT)}`}
              />

              {_.map(dayRange, (day) => {
                const fullday = day.format(DATE_YEAR_FORMAT);
                const active = fullday === _.get(query, "modal.date");
                return (
                  <a
                    key={fullday}
                    className={cx("day", { active })}
                    href={`/actions/refresh?modal[type]=copy&modal[date]=${fullday}`}
                  >
                    {day.format("MMM")}
                    <br />
                    {day.format("YYYY")}
                  </a>
                );
              })}

              <a
                className="next"
                href={`/actions/refresh?modal[type]=copy&modal[date]=${selectedMonth
                  .clone()
                  .add(1, "months")
                  .format(DATE_YEAR_FORMAT)}`}
              />
            </div>
          </div>
          <button className="button-input" type="submit">
            Import Workout
          </button>
        </div>
      </Modal>
    </form>
  );
}

CopyExerciseModal.contextTypes = { locals: PropTypes.object };

export { id };
export { CopyExerciseModal as default };
